<template>
    <div class="registrationWrapper">
        <div class="container">
            <div class="whiteBG-wrap">
                <div class="row">                
                    <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-7">
                        <div class="regForm-wrap">
                            <h2>Group Address Information</h2>
                            <hr>
                            <address-form />
                        </div>
                    </div>
                    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-5">
                        <address-side-info />
                    </div>                    
                </div>
                <span class="procecss-title">Employer Registration</span>
            </div>
        </div>        
    </div>
</template>
<script>
import AddressForm from '../../components/Registration/AddressInfo/AddressForm.vue'
import AddressSideInfo from '../../components/Registration/AddressInfo/AddressSideInfo.vue'
export default {
    name: 'AddressInfo',
    components: {
        AddressForm,
        AddressSideInfo
    }
}
</script>
<style src="../../assets/css/group-registration.css"></style>